// extracted by mini-css-extract-plugin
export default {"alert":"static-React-HVJS-HVUI-Alert-___Alert-module__alert","alert-slim":"static-React-HVJS-HVUI-Alert-___Alert-module__alert-slim"};